module.exports = __webpack_public_path__ + "img/ice_cream.f09adb4d.jpg";